export const TOTP_REGEX = /[0-9]/
